export default __webpack_public_path__ + "media/images/partners/criem-c19e5ac9505f15d8872ac04139fa9407.png";